import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, Row, Col, Spinner, Table } from 'react-bootstrap';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import ReactDatePicker from "react-datepicker";
import ReusableTable from '../../components/ReusableTable';
import Header from '../../layouts/Header';

const CancellationRequests = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    
    const accessToken = localStorage.getItem("authToken");
    const [cancelationList, setCancelationList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(false);
    const [error, setError] = useState('');
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [openViewModal, setOpenViewModal] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState({});
    const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
    const [cancellationId, setCancellationId] = useState("")
    const [refundId, setRefundId] = useState("");
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [clicked, setClicked] = useState(false);

    const columns = [
        {
            header: "Sr.No",
            accessor: "serialNumber",
            render: (value, row, index) => <div className="fs-7">{row.serialNumber ? row.serialNumber : "--------"}</div>,
        },
        {
            header: "Order NO",
            accessor: "orderDetails.order_no",
            render: (value, row) => <div className="fs-7 fw-semibold">A{row.orderDetails?.order_no ? row.orderDetails?.order_no : "--------"}</div>,
        },
        {
            header: "Order Created At",
            accessor: "createdAt",
            render: (value) => <div className="fs-7">{value ? new Date(value).toLocaleString() : "--------"}</div>,
        },
        {
            header: "Customer Name",
            accessor: "customerDetails.name",
            render: (value, row) => <div className="fs-7"><span className='text-success fw-semibold'>{row?.customerDetails?.name ? row?.customerDetails?.name : "--------"}</span></div>,
        },
        {
            header: "Refund Status",
            accessor: "refundStatus",
            render: (value) => <div className="fs-7" style={{ color: value === false ? 'red' : 'green' }}>{value === false ? "PENDING" : "COMPLETED"}</div>,
        },
        {
            header: "Refund Response",
            accessor: "refundResponse",
            render: (value) => <div className="fs-7">{value ? value?.refund_id : "--------"}</div>,
        },
        {
            header: "ACTIONS",
            render: (value, row) => (
                <div className='w-100' style={{ display: 'flex', alignItems: "center", gap: '10px' }}>
                    <Button
                        size="sm"
                        className="w-100 fw-semibold"
                        style={{
                            borderRadius: '20px',
                            fontSize: '11px',
                            backgroundColor: '#1E9CED',
                            color: 'white',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            transition: 'background-color 0.3s, transform 0.3s',
                            transform: 'scale(1.05)',
                            border: "none"
                        }}
                        onClick={() => handleViewDetails(row)}
                    >
                        View Details
                    </Button>

                    {
                        row?.refundStatus === false && <Button
                            size="sm"
                            className="w-100 fw-semibold"
                            style={{
                                borderRadius: '20px',
                                fontSize: '11px',
                                backgroundColor: '#4caf50',
                                color: 'white',
                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                transition: 'background-color 0.3s, transform 0.3s',
                                transform: 'scale(1.05)',
                                border: "none"
                            }}
                            onClick={() => handleOpenUpdateStatusModal(row)}
                        >
                            Refund
                        </Button>
                    }
                </div>
            ),
        },
    ];

    const getCancellationRequests = async (startDate, endDate, outlet, status, search) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let url = `order-cancellation-requests?startDate=${startDate?.toISOString().split("T")[0]}&endDate=${endDate?.toISOString().split("T")[0]}`;

            if (outlet && outlet !== '') {
                url += `&outletId=${outlet}`;
            }
    
            if (status !== null && status !== undefined) {
                url += `&refundStatus=${status}`;
            }
    
            if (search && search !== '') {
                url += `&search=${search}`;
            }

            const response = await axiosInstance.get(url, { headers });

            response?.data?.data?.forEach((item, index) => {
                item.serialNumber = index + 1;
            });

            if (response?.data?.status === true) {
                toast.success("Data Fetched Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            } else {
                toast.error(response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            setCancelationList(response?.data?.data);
            setFilteredData(response?.data?.data);

        } catch (error) {
            console.log("error :", error);

            if (error?.response) {
                let errorMessage = '';
                if (error?.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (error?.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error?.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
            }
        }
    }

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutletList(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleViewDetails = async (data) => {
        setOpenViewModal(true);
        console.log("View Details Modal :", data)
        setSelectedRequest(data);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
    }

    const handlePageChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage });
    };

    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
        const endIndex = startIndex + pagination.rowsPerPage;
        return cancelationList?.slice(startIndex, endIndex);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

        await getCancellationRequests(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedStatus, searchText);
        setSubmitBtnLoading(false);
    };

    const handleOpenUpdateStatusModal = (data) => {
        const cancellationId = data?._id;
        setCancellationId(cancellationId);
        setOpenUpdateStatusModal(true);
    }

    const handleCloseUpdateStatusModal = () => {
        setOpenUpdateStatusModal(false)
    }

    const updateCancellationStatus = async (e) => {
        e.preventDefault()
        setIsEditBtnLoading(true)
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: cancellationId,
                refund_id: refundId
            }

            const response = await axiosInstance.put("order-cancellation-requests", data, { headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setCancellationId("");
                setRefundId("")
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

                await getCancellationRequests(adjustedStartDate, adjustedEndDate, selectedOutlet, selectedStatus, searchText);
                setOpenUpdateStatusModal(false);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsEditBtnLoading(false)
        }
    }

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        setStartDate(start);
        setEndDate(end);

        getCancellationRequests(start, end, selectedOutlet, selectedStatus);
    }, []);

    useEffect(() => {
        if (searchText === "" && clicked) {
            getCancellationRequests(startDate, endDate, selectedOutlet, selectedStatus);
        }
    }, [searchText]);

    useEffect(() => {
        getOutlets();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="mb-3">
                        <Col className="pt-4">
                            <h5 className="fw-semibold">CANCELLATION REQUESTS</h5>
                        </Col>
                        <hr className='mb-0' />
                    </Row>

                    <Row className="mb-4">
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Select Outlet</Form.Label>
                            <Form.Select
                                id="selectField"
                                name="selectField"
                                value={selectedOutlet}
                                onChange={(e) => setSelectedOutlet(e.target.value)}
                            >
                                <option value="">Select Outlet</option>
                                {outletList?.map((out) => (
                                    <option key={out?._id} value={out?._id}>{out?.name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Select Refund Status</Form.Label>
                            <Form.Select
                                id="selectField"
                                name="selectField"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="">Select Refund Status</option>
                                <option value="true">COMPLETED</option>
                                <option value="false">PENDING</option>
                            </Form.Select>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Start Date</Form.Label>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <ReactDatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Select Start Date"
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>End Date</Form.Label>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <ReactDatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Select End Date"
                                    className="form-control"
                                />
                                {error && <div className="text-danger" style={{ fontSize: '14px' }}>{error}</div>}
                            </div>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Search By Name"
                                onChange={(e) => 
                                    {
                                        setSearchText(e.target.value)
                                        setClicked(true);
                                    }
                                }
                            />
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            <Button 
                                variant="primary" 
                                className="w-100"
                                onClick={handleSubmit}
                                disabled={submitBtnLoading}
                            >
                                {submitBtnLoading ? <Spinner size="sm" animation="border" /> : 'Submit'}
                            </Button>
                        </Col>
                    </Row>

                    <ReusableTable
                        columns={columns}
                        data={getPaginatedData()}
                        rowKey="_id"
                        loading={loading}
                        currentPage={pagination.page}
                        totalPages={Math.ceil(cancelationList?.length / pagination.rowsPerPage)}
                        onPageChange={handlePageChange}
                        recordsPerPage={pagination.rowsPerPage}
                        onRecordsPerPageChange={handleRowsPerPageChange}
                        isServerSidePagination={false}
                    />

                    <Modal
                        show={openViewModal}
                        onHide={handleCloseViewModal}
                        size="xl"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="text-center w-100">ORDER CANCELLATION REQUEST DETAILS</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedRequest ? (
                                <div className="p-3">
                                    <h6>CUSTOMER DETAILS -</h6>
                                    <Row>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Customer Name :</h6>
                                            <p>{selectedRequest?.customerDetails?.name}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Email :</h6>
                                            <p>{selectedRequest?.customerDetails?.email?.includes("_deleted_")
                                                ? `${selectedRequest?.customerDetails?.email?.split("_deleted_")[0]} [Deleted]`
                                                : selectedRequest?.customerDetails?.email}
                                            </p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Mobile :</h6>
                                            <p>{selectedRequest?.customerDetails?.mobile?.includes("_deleted_")
                                                ? `${selectedRequest?.customerDetails?.mobile?.split("_deleted_")[0]} [Deleted]`
                                                : selectedRequest?.customerDetails?.mobile}
                                            </p>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <h6>OUTLET DETAILS -</h6>
                                    <Row>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Outlet Name :</h6>
                                            <p>{selectedRequest?.orderDetails?.outlet?.name}</p>
                                        </Col>
                                        <Col xs={8}>
                                            <h6 className='text-secondary'>Outlet Address :</h6>
                                            <p>{selectedRequest?.orderDetails?.outlet?.address}</p>
                                        </Col>
                                    </Row>

                                    <h6>CANCELLATION DETAILS -</h6>
                                    <Row className="mb-2">
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Cancellation Req Id :</h6>
                                            <p>{selectedRequest?._id}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Request Created On :</h6>
                                            <p>
                                                {new Date(selectedRequest?.createdAt).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                })}
                                                {" / "}
                                                {new Date(selectedRequest?.createdAt).toLocaleTimeString('en-US', {
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    hour12: true,
                                                })}
                                            </p>
                                        </Col>
                                    </Row>
                                    <hr />

                                    <h6>PAYMENT DETAILS -</h6>
                                    <Row>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Razorpay Payment Id :</h6>
                                            <p>{selectedRequest?.paymentDetails?.gatewayResponse?.razorpayPaymentId}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Razorpay Order Id :</h6>
                                            <p>{selectedRequest?.paymentDetails?.gatewayResponse?.razorpayOrderId}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Razorpay Receipt Id :</h6>
                                            <p>{selectedRequest?.paymentDetails?.receiptId}</p>
                                        </Col>

                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Refund Status :</h6>
                                            <p className={`${selectedRequest?.refundStatus === false ? 'text-warning' : 'text-success'} `}>
                                                {selectedRequest?.refundStatus === false ? "PENDING" : "COMPLETED"}
                                            </p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Refund Response :</h6>
                                            <p>{selectedRequest?.refundResponse === null ? "Waiting For Response" : "DONE"}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Status Updated On :</h6>
                                            <p>
                                                {
                                                    selectedRequest?.updatedAt !== selectedRequest?.createdAt ? (
                                                        <>
                                                            {new Date(selectedRequest?.updatedAt).toLocaleDateString('en-US', {
                                                                year: 'numeric',
                                                                month: 'long',
                                                                day: 'numeric',
                                                            })}
                                                            {" / "}
                                                            {new Date(selectedRequest?.updatedAt).toLocaleTimeString('en-US', {
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                hour12: true,
                                                            })}
                                                        </>
                                                    ) : (
                                                        "Yet To Be Updated"
                                                    )
                                                }
                                            </p>
                                        </Col>
                                    </Row>
                                    <hr />

                                    <h6>ORDER DETAILS -</h6>
                                    <Row>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Order No :</h6>
                                            <p>{selectedRequest?.orderDetails?.order_sequence}{selectedRequest?.orderDetails?.order_no}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Order Type :</h6>
                                            <p>{selectedRequest?.orderDetails?.ordersType}</p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Date & Time :</h6>
                                            <p>
                                                {new Date(selectedRequest?.orderDetails?.createdAt).toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'long',
                                                    day: 'numeric',
                                                })}
                                                {" / "}
                                                {new Date(selectedRequest?.orderDetails?.createdAt).toLocaleTimeString('en-US', {
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    hour12: true,
                                                })}
                                            </p>
                                        </Col>
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Coupon Applied :</h6>
                                            <p>{selectedRequest?.couponDetails ? "YES" : "NO"}</p>
                                        </Col>
                                        {selectedRequest?.couponDetails && (
                                            <>
                                                <Col xs={4}>
                                                    <h6 className='text-secondary'>Coupon Name :</h6>
                                                    <p>{selectedRequest?.couponDetails?.title}</p>
                                                </Col>
                                                <Col xs={4}>
                                                    <h6 className='text-secondary'>Coupon Code :</h6>
                                                    <p className='fw-semibold' style={{ color: 'purple' }}>{selectedRequest?.couponDetails?.couponCode}</p>
                                                </Col>
                                                <Col xs={4}>
                                                    <h6 className='text-secondary'>Usage Type :</h6>
                                                    <p>{selectedRequest?.couponDetails?.usageType}</p>
                                                </Col>
                                            </>
                                        )}
                                        <Col xs={4}>
                                            <h6 className='text-secondary'>Grand Total :</h6>
                                            <p className='text-success fw-semibold'>₹. {selectedRequest?.orderDetails?.grandTotal.toFixed(2)}</p>
                                        </Col>
                                    </Row>
                                    <hr />

                                    <Row className="mb-2">
                                        <h6>ORDERED ITEMS -</h6>
                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th className="fw-semibold">Product</th>
                                                    <th className="text-center fw-semibold">Quantity</th>
                                                    <th className="text-center fw-semibold">Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedRequest?.orderItems?.map((item) => (
                                                    <tr key={item?._id}>
                                                        <td>{item?.product?.name}
                                                            {item?.addons?.length > 0 ? (
                                                                <ul style={{ fontSize: '14px' }}>
                                                                    {item?.addons?.map((addon) => (
                                                                        <li key={addon?._id}>
                                                                            {addon?.selectedValue} (₹{addon?.price})
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </td>
                                                        <td className="text-center">{item?.quantity}</td>
                                                        <td className="text-end">
                                                            ₹{selectedRequest?.couponDetails?.isMrpDiscount && item.discount > 0 ? item?.mrpRate : item?.rate?.toFixed(2)}
                                                            <ul style={{ fontSize: '14px', listStyleType: 'none' }}>
                                                                {item?.addons?.map((addon) => (
                                                                    <li key={addon?._id}>
                                                                        + (₹{addon?.price})
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {selectedRequest?.orderDetails?.platformFees !== 0 && (
                                                    <tr>
                                                        <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>
                                                            Platform Fees:
                                                        </td>
                                                        <td style={{ fontSize: '14px' }} className="text-end">
                                                            ₹ {Number(selectedRequest?.orderDetails?.platformFees).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}

                                                {selectedRequest?.orderDetails?.packingCharges !== 0 && null && (
                                                    <tr>
                                                        <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>Packing Fees:</td>
                                                        <td style={{ fontSize: '14px' }} className="text-end">
                                                            ₹ {selectedRequest?.orderDetails?.packingCharges?.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}

                                                {selectedRequest?.orderDetails?.deliveryCharges !== 0 && null && (
                                                    <tr>
                                                        <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>Delivery Charges:</td>
                                                        <td style={{ fontSize: '14px' }} className="text-end">
                                                            ₹ {selectedRequest?.orderDetails?.deliveryCharges?.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr>
                                                    <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>Total</td>
                                                    <td style={{ fontSize: '14px' }} className="text-end">
                                                        ₹{(
                                                            selectedRequest?.orderItems?.reduce((acc, item) => {
                                                                const basePrice = selectedRequest?.couponDetails?.isMrpDiscount ? item?.mrpRate : item?.rate;
                                                                const addonsPrice = item?.addons?.reduce((sum, addon) => sum + addon?.price, 0);
                                                                return acc + (basePrice * item?.quantity) + (addonsPrice * item?.quantity);
                                                            }, 0) +
                                                            (selectedRequest?.orderDetails?.platformFees || 0) +
                                                            (selectedRequest?.orderDetails?.packingCharges || 0) +
                                                            (selectedRequest?.orderDetails?.deliveryCharges || 0)
                                                        ).toFixed(2)}
                                                    </td>
                                                </tr>

                                                <tr style={{ borderBottom: '1px solid #9e9b9b' }}>
                                                    <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>Total Discount:</td>
                                                    <td style={{ fontSize: '14px' }} className="text-end">
                                                        (-) ₹ {selectedRequest?.orderDetails?.totalDiscount?.toFixed(2)}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}></td>
                                                    <td style={{ fontSize: '14px' }} className="text-end text-muted fw-semibold">
                                                        ₹{(
                                                            (
                                                                selectedRequest?.orderItems?.reduce((acc, item) => {
                                                                    const basePrice = selectedRequest?.couponDetails?.isMrpDiscount ? item?.mrpRate : item?.rate;
                                                                    const addonsPrice = item?.addons?.reduce((sum, addon) => sum + addon?.price, 0);
                                                                    return acc + (basePrice * item?.quantity) + (addonsPrice * item?.quantity);
                                                                }, 0) +
                                                                (selectedRequest?.orderDetails?.platformFees || 0) +
                                                                (selectedRequest?.orderDetails?.packingCharges || 0) +
                                                                (selectedRequest?.orderDetails?.deliveryCharges || 0)
                                                            ) - (selectedRequest?.orderDetails?.totalDiscount || 0)
                                                        ).toFixed(2)}
                                                    </td>
                                                </tr>

                                                <tr style={{ borderBottom: '1px solid #000' }}>
                                                    <td colSpan={2} className="text-end" style={{ fontSize: '14px' }}>Total Tax Amount:</td>
                                                    <td style={{ fontSize: '14px' }} className="text-end fw-semibold">
                                                        (+) ₹ {selectedRequest?.orderDetails?.totalTaxAmount?.toFixed(2)}
                                                    </td>
                                                </tr>

                                                <tr style={{ borderBottom: '1px solid #000' }}>
                                                    <td colSpan={2} className="text-end"><strong>Grand Total:</strong></td>
                                                    <td className="text-end text-success fw-semibold">
                                                        ₹. {selectedRequest?.orderDetails?.grandTotal.toFixed(2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Row>
                                </div>
                            ) : (
                                <p>No details available.</p>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseViewModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal
                        centered
                        show={openUpdateStatusModal}
                        onHide={handleCloseUpdateStatusModal}
                        size="md"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="text-center w-100">UPDATE CANCELLATION REQUEST STATUS</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={updateCancellationStatus}>
                            <Modal.Body>
                                <div>
                                    <Form.Label className="fw-semibold">
                                        Enter Refund ID <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Refund ID"
                                        className="form-control no-arrows"
                                        name="refundId"
                                        value={refundId}
                                        onChange={(e) => setRefundId(e.target.value)}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button 
                                    variant="primary" 
                                    type="submit"
                                    disabled={isEditBtnLoading}
                                >
                                    {isEditBtnLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : 'SAVE CHANGES'}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CancellationRequests;